import Skeleton from '@ingka/skeleton';

import { QueryError } from '@/components/query-error';

import { useAssetParams, useBarCode } from '@/hooks/asset.hooks';

import styles from './styles.module.scss';

interface Props {
    imgOnly?: boolean;
}
export const BarCode = ({ imgOnly }: Props) => {
    const { assetId } = useAssetParams();

    const { data, isError, isLoading, error } = useBarCode(assetId);
    if (isError) {
        return <QueryError error={error} />;
    }
    if (isLoading) {
        return <Skeleton width="289px" height="81px" />;
    }
    if (!data) {
        return null;
    }

    if (imgOnly) {
        return <img src={`data:image/png;base64,${data.barCode}`} alt="barcode" data-testid="barcode-imgonly" />;
    }

    return (
        <div className={styles.barcode_container} data-testid="barcode-container">
            <img src={`data:image/png;base64,${data.barCode}`} alt="barcode" />
        </div>
    );
};
